import React from "react";
import { Col, Container, Row } from "react-bootstrap";
import { StaticImage } from "gatsby-plugin-image";
import { Link } from "gatsby";

const Whychooseusa = () => {
  return (
    <div className="whychooseusa p-100">
      <Container className="h-100">
        <Row className="h-100">
          <Col
            xs={12}
            md={10}
            lg={10}
            xl={10}
            xxl={10}
            className="m-auto text-center"
          >
            <h2>
              <span>Why Choose</span> TekRevol As Your Cross-Platform App
              Development Company?
            </h2>
          </Col>
        </Row>
        <Row className="h-100 choose_padd">
          <Col xs={12} md={6} lg={5} xl={5} xxl={5}>
            <p>
              TekRevol knows cross-platform app development at its core. Our
              passion for learning and adapting to the latest tech gives us an
              edge over our competition.
            </p>
            <p>
              We harness the power of the latest technologies for cross-platform
              app development and deliver apps that run smoothly on various
              platforms.
            </p>
            <p>
              TekRevol's cross-platform prowess guarantees cost-effectiveness,
              rapid deployment, and a strategic edge in the ever-evolving
              market, marking a seamless journey toward app excellence and
              market dominance.
            </p>
            <p>
              Choosing TekRevol for your cross platform mobile application
              development guarantees a myriad of benefits derived from our
              specialized proficiency and unwavering dedication to achieving
              excellence.
            </p>
            <Link
              to="/contact"
              className="border_btn dark_btn"
              aria-label="TekRevol Contact"
            >
              Schedule A Free Consultation Session
            </Link>
          </Col>
          <Col xs={12} md={6} lg={7} xl={7} xxl={7}>
            <StaticImage
              src="../../images/services-usa/and/Why-Choose.webp"
              alt="tekrevol_android"
              layout="constrained"
              placeholder="blurred"
              formats={["webp"]}
              width={910}
              height={650}
            />
          </Col>
        </Row>
      </Container>
    </div>
  );
};

export default Whychooseusa;
